// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Check assignment'">
  </sub-header>
  <div class="tab-content" style="overflow: unset">
    <div class="tab-pane active" id="tab_types">
      <table class="table" ng-table="\$ctrl.tableConfig">
        <thead>
        <tr>
          <th>No</th>
          <th>Name</th>
          <th>Approved loans</th>
          <th></th>
        </tr>
        </thead>
        <tr ng-repeat="branch in \$data">
          <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
          <td>{{branch.name}}</td>
          <td>{{branch.noOfUnassignedLoans}}</td>
          <td>
            <div class="buttons">
              <button
                type="button"
                class="btn btn-warning"
                ng-click="\$ctrl.goToCheckAssignment(branch)">
                Open
              </button>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/check-preparation/assignment/check-assignment-branch-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;